export const regexTest = (pattern: RegExp, source: string, global: boolean, caseInsensitive: boolean): any => {
  const regex: RegExp = new RegExp(pattern.source, (global ? 'g' : '') + (caseInsensitive ? 'i' : ''));
  return regex.test(source);
};
